import SuwaneeHeroSection from "./components/HeroSection";
import SuwaneeStickyNav from "./components/StickyNav";
import SuwaneeProcessingTimeSection from "./components/ProcessingTimeSection";
import SuwaneeServicesSection from "./components/ServicesSection";
import SuwaneeLocalAreaSection from "./components/LocalAreaSection";
import SuwaneeTestimonialsSection from "./components/TestimonialsSection";
import SuwaneeAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import SuwaneeComparisonSection from "./components/ComparisonSection";
import SuwaneeMistakesSection from "./components/MistakesSection";
import SuwaneeHowItWorksSection from "./components/HowItWorksSection";
import SuwaneeFAQSection, { faqs } from "./components/FAQSection";
import SuwaneeHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import SuwaneeFinalCTA from "./components/FinalCTA";
import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function SuwaneePage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Suwanee"
        state="Georgia"
        stateAbbr="GA"
        route="/cities/suwanee"
        title="Emergency Passport Suwanee, GA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Suwanee, GA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Gwinnett County travelers. Get your emergency passport fast!"
        geoPlacename="Suwanee, Georgia"
        geoPosition="34.0515;-84.0713"
        keywords="expedited passport, emergency passport, Suwanee passport, same day passport Atlanta, fast passport Georgia"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Georgia"
        statePageRoute="/states/georgia"
      />
      <SuwaneeHeroSection />
      <SuwaneeStickyNav />
      <SuwaneeProcessingTimeSection />
      <SuwaneeServicesSection />
      <SuwaneeLocalAreaSection />
      <SuwaneeTestimonialsSection />
      <SuwaneeAcceptanceFacilitiesSection />
      <SuwaneeComparisonSection />
      <SuwaneeMistakesSection />
      <SuwaneeHowItWorksSection />
      <SuwaneeFAQSection />
      <SuwaneeHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/suwanee" state="GA" />
      <SuwaneeFinalCTA />
    </div>
  );
}